import { render } from "./pharmInfo.vue?vue&type=template&id=6fdc6066"
import script from "./pharmInfo.vue?vue&type=script&lang=js"
export * from "./pharmInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__